import {createAction} from 'redux-actions';
import {setCookie} from '../../../utils/dom-utils';
import {getQueryStringValue, isMobileCookieSet} from "../../../utils/utils";

const isSandbox = window.location.host.includes('localhost');
const isInternalDomain = window.location.host.includes('awstrp');
const inIFrame = window.self !== window.top && (isSandbox || isInternalDomain);
const isSalesforce =
    window.location.pathname.includes('salesforce') &&
    (isSandbox || isInternalDomain);

const DEFAULT_STATE = {
  isLoading: false,
  isLoaded: false,
  hasFailed: false,
  isIFrame: inIFrame,
  isSalesforceRep: isSalesforce,
  apiKey: "",
  error: null,
  isMobileParam: false
};

/* Action Types */
export const SET_SALESFORCE_REP = 'SET_SALESFORCE_REP';
export const GET_API_KEY = 'GET_API_KEY';
export const SET_IS_MOBILE_PARAM = 'SET_IS_MOBILE_PARAM';

/* Reducers */
export default function userProductTypes(
  state = DEFAULT_STATE,
  { payload, type }
) {
  switch (type) {

    case SET_SALESFORCE_REP: {
      return {
        ...state,
        isIFrame: payload.isIFrame,
        isSalesforceRep: payload.isSalesforceRep,
        webViewEnabled: isInternalDomain && !payload.isSalesforceRep,
      };
    }

    case SET_IS_MOBILE_PARAM: {
      return {
        ...state,
        isMobileParam: payload,
      };
    }

    case `${GET_API_KEY}_PENDING`:
      return {
        ...state,
        isLoaded: false,
        isLoading: true
      };

    case `${GET_API_KEY}_FULFILLED`:
      return {
        ...state,
        isLoaded: true,
        isLoading: false,
        apikey: payload.apiKey,
        environment: payload.environment
      };

    case `${GET_API_KEY}_REJECTED`:
      return {
        ...state,
        isLoaded: true,
        isLoading: false,
        hasFailed: true,
        error: payload
      };
    default:
      return state;
  }
}

/* Actions */
export const setSalesforceRep = (salesforceRepData) => {
  return (dispatch) =>
      dispatch({
        type: SET_SALESFORCE_REP,
        payload: salesforceRepData,
      });
};

export const setAdditionalParams = () => {
  return (dispatch) => {
    if (getQueryStringValue('mobile') === '1' && !isMobileCookieSet()) {
      setCookie('additionalParams', window.location.search, 36500);
      const action = createAction(`${SET_IS_MOBILE_PARAM}`)(true);
      return dispatch(action)
    } else if (getQueryStringValue('mobile') === '1' || isMobileCookieSet()) {
      const action = createAction(`${SET_IS_MOBILE_PARAM}`)(true);
      return dispatch(action)
    } else {
      const action = createAction(`${SET_IS_MOBILE_PARAM}`)(false);
      return dispatch(action)
    }
  };
};

export const getAPIKey = () => {
  const basePath = document.location.origin;
  const baseURL = `${basePath}/usis/rmd-tool`;
  const isLocalhost =
    window &&
    window.location.hostname.toLowerCase().indexOf('localhost') !== -1;
  const apiUrl = isLocalhost ? `${baseURL}/api-conf.json` : `${baseURL}/api-config-v2.json`;
  return (dispatch) => {
    const action = createAction(GET_API_KEY)(fetch(apiUrl).then(res => res.json()));

    try {
      return dispatch(action);
    } catch (e) {
      console.error(e);
    }
  };
};
